export const SITTER_DASHBOARD_LOADED = 'Sitter Dashboard Loaded';
export const PARENT_DASHBOARD_LOADED = 'Parent Dashboard Loaded';
export const SHOW_PARENT_SMS_MODAL = 'Show Parent SMS Modal';
export const SHOW_SITTER_SMS_MODAL = 'Show Sitter SMS Modal';
export const JOB_POST_LOCATION_LOADED = 'Job Post Location Loaded';
export const JOB_POST_SELECT_SCHEDULE_LOADED = 'Job Post Select Schedule Loaded';
export const JOB_POST_SCHEDULE_LOADED = 'Job Post Schedule Loaded';
export const JOB_POST_FAMILY_DETAILS_LOADED = 'Job Post Family Details Loaded';
export const JOB_POST_RATES_LOADED = 'Job Post Rates Loaded';
export const JOB_POST_REQUIREMENTS_LOADED = 'Job Post Requirements Loaded';
export const JOB_POST_DETAILS_LOADED = 'Job Post Details Loaded';
export const JOB_POST_HEADLINE_LOADED = 'Job Post Headline Loaded';
export const JOB_POST_CONFIRM_LOADED = 'Job Post Confirm Loaded';
export const BASIC_REGISTRATION_LOCATION_LOADED = 'Basic Registration Location Loaded';
export const BASIC_REGISTRATION_HOW_DID_YOU_HEAR_ABOUT_US_LOADED = 'Basic Registration How Did You Hear About Us Loaded';
export const BASIC_REGISTRATION_ADD_YOUR_EMPLOYER_LOADED = 'Basic Registration Add Your Employer Loaded';
export const BASIC_REGISTRATION_CARE_TYPE_LOADED = 'Basic Registration Care Type Loaded';
export const SITTER_SEARCH_LOADED = 'Sitter Search Loaded';
export const REQUEST_REVIEW_PARENTS_AVAILABLE = 'Request Review Parents Available for Review';
export const REQUEST_REVIEW_NO_PARENTS_AVAILABLE = 'Request Review No Parents Available for Review';
export const REQUEST_REVIEW_SUBMITTED = 'Request Review Submitted';
export const CONTACT_GATE_PRICING_PAGE_VIEWED = 'Contact Gate Pricing Page Viewed';
